// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__3QF_k","dark":"Button_dark__7MfcW","minimal":"Button_minimal__2IN_O","icon":"Button_icon__23JL_"};